import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TablerIconComponent } from 'angular-tabler-icons';
import { filter } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/base/base.component';
import { I18nPipe } from '../../pipes/i18n.pipe';

@Component({
   selector: 'app-footer',
   standalone: true,
   imports: [TablerIconComponent, I18nPipe, RouterModule],
   templateUrl: './footer.component.html',
})
export class FooterComponent extends BaseComponent implements OnInit {
   private router = inject(Router);
   active = 'inicio';

   ngOnInit(): void {
      this.updateActive(this.router.url);
      this.router.events
         .pipe(
            filter((event): event is NavigationEnd => event instanceof NavigationEnd),
            this.takeUntilDestroy(),
         )
         .subscribe((event) => this.updateActive(event.urlAfterRedirects));
   }

   private updateActive(url: string): void {
      const path = url.split('?')[0].toLowerCase();
      if (path.includes('/empresas')) this.active = 'empresas';
      else if (path.includes('/beneficios')) this.active = 'beneficios';
      else if (path.includes('/resgates')) this.active = 'resgates';
      else if (path.includes('/perfil')) this.active = 'perfil';
      else this.active = 'inicio';
   }
}
